/* Project Import will be here */
import { moveFileInS3 } from './awsHelper';
/* Project Import will be here */

/* Move the image file from temp folder to actual folder */
export const moveImageFromTempToMain = (awsConfig, sourceImagePath, destinationPath) => {
    /* remove the static file URL from sourceImagePath */
    let sourceUrl = awsConfig.DirectoryAccess + sourceImagePath.replace(awsConfig.StaticUrl, "");
    const fileNameSplit = sourceImagePath.split('/');

    return new Promise((resolve, reject) => {
        /* Call the AWS helper to move the file */
        moveFileInS3({
            sourceFilePath: sourceUrl,
            destinationFilePath: destinationPath + fileNameSplit[fileNameSplit.length - 1],
            awsConfig: awsConfig,
        }).then(() => {
            /* Get the success response */
            const successResponse = {
                status: true,
                updatedUrl: awsConfig.StaticUrl + destinationPath.replace(awsConfig.DirectoryAccess, "") + fileNameSplit[fileNameSplit.length - 1]
            };
            resolve(successResponse);
        }).catch(() => {
            /* Get the error response */
            const errorResponse = {
                status: false,
                updatedUrl: ""
            };
            resolve(errorResponse);
        });
    });
}